import { render, staticRenderFns } from "./Manifests.vue?vue&type=template&id=010d2647&scoped=true"
import script from "./Manifests.vue?vue&type=script&lang=ts"
export * from "./Manifests.vue?vue&type=script&lang=ts"
import style0 from "./Manifests.vue?vue&type=style&index=0&id=010d2647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d2647",
  null
  
)

export default component.exports